<div class="modal-dialog product-details-dialog">
  <div class="modal-content flex-direction-row">
    <mat-icon class="dialog-close-icon" (click)="closeDialog()">close</mat-icon>

    <div class="flex-direction-column product-details-left">
      <img class="product-details-left-img" [src]="getProductImageUrl(selectedImage)" alt="product">

      @if (getProductCard.imageUrls.length>1) {
        <div class="pictures-scroll-container">
          @for (pic of getProductCard.imageUrls; track $index) {
            <div class="picture-item cursor-pointer">
              <img
                [src]="getProductImageUrl(pic)"
                [class.selected]="pic === selectedImage"
                (click)="changeSelectedImage(pic)"
                alt="thumbnail">
            </div>
          }
        </div>
      }
    </div>

    <div class="flex-direction-column max-w-450px">
      <span class="product-name my-2">{{ getProductCard.productName }}</span>
      <span class="product-price">
        ${{ totalPriceUSD | number:'1.1-1' }} / {{ totalPriceAMD }}
        <span style="font-size: 14px;">{{ 'subscription_plan_content.AMD' | translate }}</span>
      </span>

      <span class="product-description-headline mt-20px">
        {{ 'products_content.description' | translate }}
      </span>
      <span class="product-details-text" [innerHTML]="getProductCard.productDescription" ></span>


      @if (getProductCard.compatibilityDescription) {
        <span class="product-description-headline mt-20px">
        {{ 'products_content.compatibility' | translate }}
      </span>
        <div class="mt-2">
          <span class="product-details-text" [innerHTML]="getProductCard.compatibilityDescription"></span>
        </div>
      }

      <div class="my-1 cursor-pointer">
        @for (attribute of getProductCard.attributeValues; track attribute) {
          <div class="color-box mx-2"
               [class.selected]="selectedColor === attribute.id"
               [style.background-color]="attribute.value"
               (click)="selectColor(attribute)">
          </div>
        }
      </div>

      <div class="quantity-selector">
        <button (click)="decreaseQuantity()" [disabled]="quantity <= 1">&minus;</button>
        <span>{{ quantity }}</span>
        <button (click)="increaseQuantity()">&plus;</button>
      </div>
      <div class="flex-direction-row mt-20px mb-4">
        <button class="filled-button tall-button mr-10px" (click)="quickShop()">{{ 'products_content.quick_shop' | translate }}</button>
        <div class="flex-direction-row align-items-center"
             [class]="getProductCard.isAddedToCart ? 'justify-content-between' : ''">
          <button class="text-button tall-button"
                  [class]="getProductCard.isAddedToCart ? 'selected-cart-button' : ''"
                  (click)="addToCart()">
            {{ 'products_content.add_to_cart' | translate }}
          </button>
          @if (getProductCard.isAddedToCart) {
            <img class="selected-card-icon" src="assets/svg/selected.svg" alt="selected">
          }
        </div>
      </div>
    </div>
  </div>
</div>
